export default "__VITE_ASSET__BdGNycwI__"